(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestDeleteNewController',EnvTestDeleteNewController);

    EnvTestDeleteNewController.$inject = ['$uibModalInstance', 'entity'];

    function EnvTestDeleteNewController($uibModalInstance, entity) {
        var vm = this;

        vm.envTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            $uibModalInstance.close({id: id});
        }
    }
})();
